import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './core/services/theme.service';
import { SocketService } from './core/services/socket.service';
import { TopLoaderComponent } from './shared/top-loader/top-loader.component';

declare var $: any;

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TopLoaderComponent],
  templateUrl: './app.component.html',
  standalone: true,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'web';

  constructor(
    private themeService: ThemeService,
    private socketService: SocketService
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.toggleLoader(false);
    }, 700);
  }

  toggleLoader(b: boolean): void {
    if (!b) {
      $('#loaderBox').stop().fadeOut();
    } else {
      $('#loaderBox').stop().fadeIn();
    }
  }

}
